<template>
  <div class="main-content">
    <div class="content">
      <!--iframe style="width: 100%; height: 100%;" :src="url"></iframe-->
      <div class="reporting-wrapper">
        <p class="reporting-title">Reporting</p>
        <div class="big-away-link-wrapper">
          <a
            href="https://niota.io/"
            class="btn btn-default big-away-link"
            target="_blank"
            >Los geht’s!</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reporting",
  data() {
    return {
      url: this.$store.state.grafanaUrl
    };
  }
};
</script>

<style scoped>
.content .settings-main .error-meldung {
  margin-top: 10%;
  text-align: center;
}

.content .settings-main .error-meldung p {
  font-size: 20px;
  font-weight: 400;
  color: #e2000f;
}
</style>
